import { INTERNAL_DOCUMENT_TYPE } from 'features/internal-document/common/types';
import { WORK_TYPE } from 'features/work/types';
import {
  DOCUMENT_MANAGEMENT_TYPE,
  SYSTEM_CATEGORY_TAB,
  WORK_SCHEDULE_URL,
} from 'routes/types';

const publicPaths = {
  forbiddenPage: () => '/forbidden',
  loginPage: () => '/auth/login',
};

const privatePaths = {
  dashboardPage: () => '/',

  /** Work Schedule module */
  workSchedulePermissionPage: () => '/work-schedule-permission',
  workSchedulePage: (type: WORK_SCHEDULE_URL.WORK_SCHEDULE) =>
    `/company-work-schedule/${type}`,
  workScheduleCreate: () => `/company-work-schedule/create`,
  workScheduleDetail: (workScheduleId: string) =>
    `/company-work-schedule/detail/${workScheduleId}`,
  workScheduleUpdate: (workScheduleId: string) =>
    `/company-work-schedule/update/${workScheduleId}`,

  /** Document module */
  internalDocumentsListPage: (type: INTERNAL_DOCUMENT_TYPE) =>
    `/documents/internal/${type}`,
  internalDocumentDetailPage: (
    type: INTERNAL_DOCUMENT_TYPE,
    documentCode: string
  ) => `/documents/internal/${type}/${documentCode}`,

  connectedDocumentsPage: (type?: INTERNAL_DOCUMENT_TYPE) =>
    `/documents/connected/${type}`,
  connectedCommitteeDocumentsPage: (type?: INTERNAL_DOCUMENT_TYPE) =>
    `/documents/connected-committee/${type}`,
  documentsManagement: (managementType?: DOCUMENT_MANAGEMENT_TYPE) =>
    `/documents/management/${managementType}`,
  documentMangagementPermission: () => `/document-management-permission`,

  /** Work module */
  workListPage: (type: WORK_TYPE) => `/work/list/${type}`,
  workDetailPage: (workCode: string) => `/work/detail/${workCode}`,

  /** Mission Module */
  missionManagementPermission: () => `/mission-management-permission`,

  /** Salary module */
  salaryManageMentPermission: () => `/salary-management-permission`,

  /** Proposal module */
  proposalManagementPermission: () => `/proposal-management-permission`,

  /** Risk module */
  riskManagementPermission: () => `/risk-management-permission`,

  /** Ultilities module */
  ultilityManagementPermission: () => `/ultility-management-permission`,
  contactPage: () => `/utility/contact`,

  /** Management module */
  moduleManagementPage: () => `/management/module`,
  systemCategoryPage: (type?: SYSTEM_CATEGORY_TAB) =>
    `/management/category/${type}`,
  accountManagementPage: () => `/management/account`,
  managementPermission: () => `/management-permission`,

  /** Report module */
  reportPage: () => `/report`,
};

const pathsMap = {
  ...publicPaths,
  ...privatePaths,
};

export type PathsMap = typeof pathsMap;

export const getPath = <TRoute extends keyof PathsMap>(
  route: TRoute,
  ...params: Parameters<PathsMap[TRoute]>
) => {
  const pathCb: (...args: any[]) => string = pathsMap[route];
  return pathCb(...params);
};
